var _defs, _path, _path2, _path3, _path4, _path5, _g, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.72 51.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .questionnaire {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "questionnaire",
    d: "m20.81,43.83h-11.21c-5.3,0-9.6-4.31-9.6-9.6V9.6C0,4.31,4.31,0,9.6,0h16.64c5.3,0,9.6,4.31,9.6,9.6v9.14c0,1.1-.9,2-2,2s-2-.9-2-2v-9.14c0-3.09-2.51-5.6-5.6-5.6H9.6c-3.09,0-5.6,2.51-5.6,5.6v24.62c0,3.09,2.51,5.6,5.6,5.6h11.21c1.1,0,2,.9,2,2s-.9,2-2,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "questionnaire",
    d: "m25.92,19.7h-9.42c-1.1,0-2-.9-2-2s.9-2,2-2h9.42c1.1,0,2,.9,2,2s-.9,2-2,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "questionnaire",
    d: "m25.92,11.87h-9.42c-1.1,0-2-.9-2-2s.9-2,2-2h9.42c1.1,0,2,.9,2,2s-.9,2-2,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "questionnaire",
    d: "m19.95,27.87h-3.56c-1.1,0-2-.9-2-2s.9-2,2-2h3.56c1.1,0,2,.9,2,2s-.9,2-2,2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "questionnaire",
    d: "m19.04,36.04h-2.66c-1.1,0-2-.9-2-2s.9-2,2-2h2.66c1.1,0,2,.9,2,2s-.9,2-2,2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "questionnaire",
    d: "m29.92,45.13c-1.1,0-2-.9-2-2v-2.91c0-1.79,1.4-3.24,3.19-3.3,3.72-.13,5.61-2,5.61-5.58,0-3.99-3.53-4.42-5.05-4.42-4.24,0-4.87,3.39-4.87,5.41,0,1.1-.9,2-2,2s-2-.9-2-2c0-4.34,2.32-9.41,8.87-9.41,5.42,0,9.05,3.39,9.05,8.42,0,5.57-3.27,9.1-8.8,9.54v2.25c0,1.1-.9,2-2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "questionnaire",
    cx: 29.92,
    cy: 48.82,
    r: 2.25
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "questionnaire",
    cx: 9.94,
    cy: 17.7,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "questionnaire",
    cx: 9.94,
    cy: 25.87,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "questionnaire",
    cx: 9.94,
    cy: 34.04,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "questionnaire",
    cx: 9.94,
    cy: 9.87,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.fd295ad4.svg";
export { ForwardRef as ReactComponent };